// axios请求配置
const config={
	baseURL:import.meta.env.VITE_BASE_URl,
	LoadingList:[],
}
export default config